import { render } from "./worker-rates-skills-dropdown.vue?vue&type=template&id=72da6f24&ts=true"
import script from "./worker-rates-skills-dropdown.vue?vue&type=script&lang=ts"
export * from "./worker-rates-skills-dropdown.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__